/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import type { Filters } from '@zcode/state-type'

export const mapPets = (filters: Filters) => {
  const pets: string[] = []
  if (filters?.cats) {
    pets.push('cats')
  }
  if (filters?.dogs) {
    pets.push('dogs')
  }
  return pets
}
